import API from "./baseApi";

const getPrograms = (payload) => {
  return API.post("/programs/get", payload);
};

const createPrograms = (payload) => {
  return API.post("/programs", payload);
};

const createProgramsNew = (payload) => {
  return API.post("/programs/new", payload);
};

const getProgramById = (payload) => {
  return API.get(`/programs/${payload}`);
};

const updateProgram = (id, payload) => {
  console.log(id, payload, "id payload");
  return API.put(`/programs/${id}`, payload);
};

export default {
  getPrograms,
  createPrograms,
  createProgramsNew,
  getProgramById,
  updateProgram,
};
